// Time tracking (Hubstaff-lite): 60s heartbeat while Talmia is visible;
// "active" = keyboard / mouse / scroll / touch input within the last 2 minutes.
import { useEffect } from "react";
import api from "../lib/api";

export default function PresenceTracker() {
  useEffect(() => {
    let lastInput = Date.now();
    const mark = () => { lastInput = Date.now(); };
    const evs = ["mousemove", "keydown", "scroll", "touchstart", "click"];
    evs.forEach((e) => window.addEventListener(e, mark, { passive: true }));
    const beat = () => {
      if (document.visibilityState !== "visible") return;
      api.post("/presence/heartbeat", { active: Date.now() - lastInput < 120000 }).catch(() => {});
    };
    beat();
    const t = setInterval(beat, 60000);
    return () => { clearInterval(t); evs.forEach((e) => window.removeEventListener(e, mark)); };
  }, []);
  return null;
}
